import { isEmptyText } from "../../lib/index.mjs";
import { Container } from "./Container.mjs";
import { Details } from "./Details.mjs";
import { Provider } from "./Provider.mjs";
import { Thumbnail } from "./Thumbnail.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BookmarkCard(props) {
  var showThumbnail = Boolean(props.showThumbnail && props.oembed.thumbnail_url);
  var isEmpty = !showThumbnail && isEmptyText(props.oembed.title) && isEmptyText(props.oembed.description);
  return /*#__PURE__*/_jsxs(Container, {
    defaultLayout: props.layout,
    hasThumbnail: showThumbnail,
    className: props.className,
    children: [showThumbnail && props.oembed.thumbnail_url && /*#__PURE__*/_jsx(Thumbnail, {
      newTab: props.newTab,
      href: props.oembed.url,
      src: props.oembed.thumbnail_url,
      width: props.oembed.thumbnail_width,
      height: props.oembed.thumbnail_height
    }), /*#__PURE__*/_jsx(Details, {
      id: props.hrefId,
      href: props.oembed.url,
      newTab: props.newTab,
      title: props.oembed.title,
      description: props.oembed.description,
      layout: props.layout,
      hasThumbnail: showThumbnail,
      children: /*#__PURE__*/_jsx(Provider, {
        showUrl: isEmpty,
        url: props.oembed.url,
        providerName: props.oembed.provider_name,
        providerUrl: props.oembed.provider_url
      })
    })]
  });
}